
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/g/submit-documents",
      function () {
        return require("private-next-pages/g/submit-documents/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/g/submit-documents"])
      });
    }
  